import Styles from "./blogs.module.css";
import bloggerImg from "../../images/BlogLogo.png";
import { Navigator } from "../../main_components/navigator.js";
import { Blog } from "./blogs_components.js";

export const BlogsBody = ( props ) => {
    const {  } = props;
    const { Body, Content } = Styles;
    const data = [
        {
            id: "13ftfgf45",
            bloggerImg: bloggerImg,
            bloggerName: "Paradox",
            blogTitle: "Technologies",
            blogDiscription: "Technology is the application of scientific knowledge and tools to solve real-world problems and improve human life. It encompasses everything from simple tools and machines to complex digital systems and software, shaping fields such as communication, healthcare, transportation, and entertainment. As it advances, technology drives innovation and efficiency, transforming industries and how people interact with each other and their environment.",
            blogTitleIcon: <i className="bi bi-chat-left-text-fill"></i>,
            blogLink: "/blogs/view_blog",
        },
        {
            id: "24jyhks92",
            bloggerImg: bloggerImg,
            bloggerName: "TechGuru",
            blogTitle: "The Future of AI",
            blogDiscription: "Artificial Intelligence (AI) is rapidly evolving, with applications in fields like healthcare, finance, and transportation. From machine learning algorithms to natural language processing, AI is transforming data into actionable insights. This revolution is paving the way for more efficient decision-making, personalized experiences, and autonomous systems.",
            blogTitleIcon: <i className="bi bi-robot"></i>,
            blogLink: "/blogs/view_blog",
        },
        {
            id: "59lkhsd21",
            bloggerImg: bloggerImg,
            bloggerName: "Innovate",
            blogTitle: "Blockchain Explained",
            blogDiscription: "Blockchain technology offers a decentralized way to manage and record transactions securely. Originally designed for cryptocurrencies like Bitcoin, it’s now applied in industries from finance to supply chain management. Blockchain’s transparency and security features are reshaping how data is managed and stored.",
            blogTitleIcon: <i className="bi bi-link-45deg"></i>,
            blogLink: "/blogs/view_blog",
        },
        {
            id: "91skjlq85",
            bloggerImg: bloggerImg,
            bloggerName: "GreenTech",
            blogTitle: "Sustainable Tech",
            blogDiscription: "Sustainable technology focuses on reducing environmental impact by using resources more efficiently and developing eco-friendly innovations. This includes renewable energy, smart cities, and eco-conscious product designs, all aimed at reducing waste and conserving natural resources.",
            blogTitleIcon: <i className="bi bi-globe"></i>,
            blogLink: "/blogs/view_blog",
        },
        {
            id: "74ihflk82",
            bloggerImg: bloggerImg,
            bloggerName: "HealthFirst",
            blogTitle: "Health Technology",
            blogDiscription: "Health technology encompasses medical devices, telemedicine, and AI-driven diagnostics. These advancements help monitor, diagnose, and treat health issues more accurately and efficiently, improving patient care and accessibility across the globe.",
            blogTitleIcon: <i className="bi bi-heart-pulse"></i>,
            blogLink: "/blogs/view_blog",
        }
    ];
    
    return (
        <main className={ Body }>
            <Navigator page={ "Blogs" }/>
            <main className={ Content }>
                { 
                    data.map(( value, key) => {
                        const { id, bloggerImg, bloggerName, blogTitle, blogLink, blogDiscription } = value;
                        return(
                            <Blog
                                id              = { id              }
                                bloggerImg      = { bloggerImg      }
                                bloggerName     = { bloggerName     }
                                blogTitle       = { blogTitle       }
                                blogLink        = { blogLink        }
                                blogDiscription = { blogDiscription }
                                key             = { key             }
                            />
                        );
                    })
                }
            </main>
        </main>
    );
};